import { Component } from '@angular/core';
import { ConfigBaseUpload, DataBaseUpload } from '../../../shared/components';
import { SnackBarService } from '../../../shared/services';
import { Department, MessageType, Segment } from '../../../shared/types';
import { CommissionsService } from './commissions.service';
import { Commissions, commissionsSchema } from './commissions.types';
import { MAP_KEYS_COMMISSIONS_FILE_TO_DB } from './commissions.utils';

@Component({
    selector: 'app-commissions',
    templateUrl: './commissions.component.html',
})
export class CommissionsComponent {
    config: ConfigBaseUpload<Commissions> = {
        title: 'Central de Comissões',
        file: {
            title: 'comissões',
            department: Department.WealthService,
            segment: Segment.Commission,
            schema: commissionsSchema,
            mapFileKeys: MAP_KEYS_COMMISSIONS_FILE_TO_DB,
        },
    };

    constructor(
        private readonly commissionsService: CommissionsService,
        private readonly snackBarService: SnackBarService
    ) {}

    public saveFile(data: DataBaseUpload) {
        const { file, details } = data;

        this.commissionsService.sendFile(file, details).subscribe({
            next: () => {
                this.snackBarService.displayMessage(
                    'Arquivo salvo com sucesso!',
                    MessageType.Success
                );
            },
            error: (error) => {
                this.snackBarService.displayMessage(
                    'Erro ao salvar arquivo!',
                    MessageType.Error
                );
                console.error(error);
            },
        });
    }
}
